import styled from "@xstyled/styled-components";

import { useJobEditFormikContext } from "../../useHandlers";

import { pxToRem } from "@otta/design-tokens";
import { FieldWrapper, SelectField } from "@otta/design";

const NarrowSelect = styled(SelectField)`
  max-width: ${pxToRem(400)};
`;

type LocationOption = { value: Location | string; label: string };

export function OfficeLocation({
  options,
  value,
}: {
  options: LocationOption[];
  value: LocationOption[];
}) {
  const form = useJobEditFormikContext();
  return (
    <FieldWrapper
      showOptionalTag={false}
      label="In-office locations"
      advice="These locations are supported by our matching algorithm."
      fieldError={
        form.touched.officeLocationPreferences
          ? form.errors.officeLocationPreferences
          : undefined
      }
    >
      {({ field }) => (
        <NarrowSelect
          inputId={field.id}
          placeholder="Type or select locations&hellip;"
          options={options}
          value={value}
          onChange={selected => {
            const newValue = selected
              ? Array.isArray(selected)
                ? selected.map(v => v.value)
                : [selected]
              : [];

            const removedLocations =
              form.values.officeLocationPreferences.filter(
                location => !newValue.includes(location)
              );

            if (removedLocations.length > 0) {
              const hiddenLocationsWithoutRemoved =
                form.values.hiddenStructuredLocationPreferences.filter(
                  location =>
                    location.location &&
                    !removedLocations.includes(location.location)
                );

              form.setFieldValue(
                "hiddenStructuredLocationPreferences",
                hiddenLocationsWithoutRemoved
              );
            }

            form.setFieldValue("officeLocationPreferences", newValue);
          }}
          onBlur={() =>
            form.setFieldTouched(
              "officeLocationPreferences",
              true,
              !!form.validateOnBlur
            )
          }
          aria-describedby={field["aria-describedby"]}
          aria-invalid={field["aria-invalid"]}
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          isMulti
        />
      )}
    </FieldWrapper>
  );
}
